import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";


// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoImage from "components/InfoImage/infoImage.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

const useStyles = makeStyles(styles);

export default function ProductSection() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}>Hair removal at its finest</h2>
          <h5 className={classes.description}>
            With over ten years of experience, our team of professionals are prepared to get your eyebrows on point and have you feeling clean and smooth.
          </h5>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <InfoImage
              title="Threading"
              description="Originating in India and Cental Asia, threading is an ancient method to swiftly and precisely remove hairs straight from their roots."
              img={require("assets/img/thread2.jpg")}
              iconColor="info"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoImage
              title="Waxing"
              description="Step into one of our clean, private rooms for our many waxing services. Please let us know of any allergies or skin conditions as we have a variety of fresh premium waxes to choose from to accomadate your needs. Our team of professionals will leave you bump-free, burn-free, and clean."
              img={require("assets/img/wax2.jpg")}
              iconColor="success"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoImage
              title="Facials"
              description="Our facials will leave your skin super smooth, clear, clean, and glowing. We use natural steam to remove all blackheads underneath your skin, and finish off with a relaxing face massage."
              img={require("assets/img/facial.jpg")}
              iconColor="danger"
              vertical
            />
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
